<template>
  <!-- 显示单个定位的地图组件 -->
  <div>
    <div id="showAllOnMap"></div>
    <!-- <el-button size="mini"
               @click="test">测试</el-button> -->
  </div>

</template>

<script>
// let marker
export default {
  name: 'show-all-location-on-map',
  data() {
    return {
      map: {},
      marker: null,
      lebel: null,
      pointerListOnMap: [],
      lableListOnMap: [],
      lat: this.latprop,
      lng: this.lngprop,
    }
  },
  props: {
    latprop: {
      type: Number,
      default: 18.22896559265385,
    },
    lngprop: {
      type: Number,
      default: 109.5366628197371,
    },
    poiList: {
      type: Array,
      default: [],
    },
  },
  mounted() {
    // console.log(this.poiList)
    this.init()
  },
  methods: {
    init() {
      let center = new TMap.LatLng(this.lat, this.lng)
      //初始化地图
      this.map = new TMap.Map('showAllOnMap', {
        zoom: 18, //设置地图缩放级别
        mapStyleId: 'style1',
        center: center, //设置地图中心点坐标
      })
      // 去掉比例尺
      this.map.removeControl(TMap.constants.DEFAULT_CONTROL_ID.SCALE)
      this.map.removeControl(TMap.constants.DEFAULT_CONTROL_ID.ROTATION)

      // 获取缩放控件实例
      let control = this.map.getControl(TMap.constants.DEFAULT_CONTROL_ID.ZOOM)
      // 设置控件位置
      control.setPosition(TMap.constants.CONTROL_POSITION.BOTTOM_RIGHT)
    },
    // 添加标记点
    pointerOnMap() {
      // console.log(this.poiList)
      // 创建 标点 选项
      this.poiList.forEach((i) => {
        let item = {
          // 列表选项参考文档：https://lbs.qq.com/webApi/javascriptGL/glGuide/glMarker
          id: i.id,
          styleId: 'markerStyle', // 标记点的样式
          position: new TMap.LatLng(i.lat, i.lng),
          properties: {
            //自定义属性
            title: 'marker1',
          },
        }
        this.pointerListOnMap.push(item)
      })

      // 构建 文本标记的 geometries
      if (this.poiList) {
        this.poiList.forEach((i) => {
          // 定位坐标
          let item = {
            // 列表选项参考文档：https://lbs.qq.com/webApi/javascriptGL/glGuide/glMarker
            id: i.id,
            styleId: 'defaultLabel', // 标记点的样式
            position: new TMap.LatLng(i.lat, i.lng),
            content: i.title,
          }
          this.lableListOnMap.push(item)
        })
      }

      // ------------------创建marker之前，判断之前是否有标点------------------
      if (this.marker) {
        // 清除点标记
        this.marker.setMap(null)
        this.marker = null
      }
      // ------------------创建点标记实例------------------
      this.marker = new TMap.MultiMarker({
        map: this.map,
        // 标记点的样式，其中myStyle 为定义的标记点的名称，在geometries的属性是使用
        styles: {
          markerStyle: new TMap.MarkerStyle({
            width: 17,
            height: 17,
            anchor: { x: 8, y: 16 },
            src: 'http://szsxtravel.top/%E5%9D%90%E6%A0%87.png',
          }),
          selectTraver: new TMap.MarkerStyle({
            width: 35,
            height: 35,
            anchor: { x: 16, y: 32 },
            src: 'http://szsxtravel.top/%E5%9D%90%E6%A0%87.png',
          }),
        },
        // geometries: geometries_list,  //点标记数据数组
      })

      //------------------初始化label------------------
      this.label = new TMap.MultiLabel({
        map: this.map, //设置折线图层显示到哪个地图实例中
        //文字标记样式
        styles: {
          // 默认样式
          defaultLabel: new TMap.LabelStyle({
            color: '#666666', //颜色属性
            size: 20, //文字大小属性
            offset: { x: 0, y: 10 }, //文字偏移属性单位为像素
            angle: 0, //文字旋转属性
            alignment: 'center', //文字水平对齐属性
            verticalAlignment: 'middle', //文字垂直对齐属性
          }),
          // 点击样式
          clickLabel: new TMap.LabelStyle({
            color: '#ff5421', //颜色属性
            size: 20, //文字大小属性
            offset: { x: 0, y: -40 }, //文字偏移属性单位为像素
            angle: 0, //文字旋转属性
            alignment: 'center', //文字水平对齐属性
            verticalAlignment: 'middle', //文字垂直对齐属性
          }),
        },
        //文字标记数据
        // geometries: [{
        //     'id': 'label_1', //点图形数据的标志信息
        //     'styleId': 'label', //样式id
        //     'position': center, //标注点位置
        //     'content': '腾讯北京总部', //标注文本
        // }]
      })

      // 添加标记点
      this.marker.add(this.pointerListOnMap)
      this.label.add(this.lableListOnMap)
      // 设置中心点
      let center = new TMap.LatLng(this.lat, this.lng)
      this.map.setCenter(center)
    },
    // 根据id 变换样式
    clickOnPointer(point_id, lat, lng) {
      let center = new TMap.LatLng(lat, lng)
      this.pointerListOnMap.forEach((item) => {
        if (item.id == point_id) {
          item.styleId = 'selectTraver'
        } else {
          item.styleId = 'markerStyle'
        }
      })

      this.lableListOnMap.forEach((item) => {
        if (item.id == point_id) {
          item.styleId = 'clickLabel'
        } else {
          item.styleId = 'defaultLabel'
        }
      })
      //
      // if (this.marker) {
      //   // 清除点标记
      //   this.marker.setMap(null)
      //   this.marker = null
      // }
      this.marker.add(this.pointerListOnMap)
      this.label.add(this.lableListOnMap)
      this.map.setCenter(center)
    },
    // 增加一个坐标，并设置中心点
    setMarkerPointerCenter(traver_id, lat, lng) {
      let center = new TMap.LatLng(lat, lng)
      this.marker.add({
        id: traver_id,
        styleId: 'selectTraver',
        position: center,
      })
      // 设置中心
      this.map.setCenter(center)
    },
    // 移除一个坐标
    removeMarkerPointer(marker_id) {
      this.marker.remove(marker_id)
    },

    // -----------------------------显示地图边界-----------------------------
    showMarkerBounds(markerArr) {
      // 创建对象：描述一个矩形的地理坐标范围。https://lbs.qq.com/javascript_gl/doc/latlngbounds.html
      var bounds = new TMap.LatLngBounds()
      //判断标注点是否在范围内
      markerArr.forEach(function (item) {
        //若坐标点不在范围内，扩大bounds范围
        if (bounds.isEmpty() || !bounds.contains(item.position)) {
          bounds.extend(item.position)
        }
      })
      //设置地图可视范围
      this.map.fitBounds(bounds, {
        padding: 100, // 自适应边距
      })
    },
  },
}
</script>

<style>
#showAllOnMap {
  width: auto;
  height: 450px;
  /* margin-top: 20px; */
}
</style>